<script setup>
import { onMounted,reactive, watch, computed } from "vue";
import { useUserStore } from "@/stores/user";
import { useCrfStore } from "@/stores/crf";

// 定义组件属性
const props = defineProps({
  formModel: {},
  type: null
});
// console.log(props.type,"入选标准的props.type");
const user = useUserStore();
// 对话框的显示状态
const patient = reactive({});

// 入选标准的表单对象
const model = reactive(props.formModel);
const crfStore = useCrfStore();
// console.log(model, "入选标准的model");
const onChange = {
  // "入选标准：极早期患者":()=>{
  //   if (model.fields[props.type]["入选标准：极早期患者"] === "否") {
  //     // 清空其他字段，单选框
  //     ["入选标准：临床存在特异性门脉高压征象", "入选标准：临床存在非特异性门脉高压征象", "入选标准：组织学表现为特异性PSVD", "入选标准：组织学表现为非特异性"].forEach((key) => {
  //       model.fields[props.type][key] = null;
  //     });
  //     // 清空其他字段，多选框
  //     ["入选标准：特异性门脉高压征象", "入选标准：非特异性门脉高压征象", "入选标准：特异性PSVD", "入选标准：非特异性"].forEach((key) => {
  //       model.fields[props.type][key] = [];
  //     });
  //   }
  // },
  "入选标准：肝活检排除肝硬化": () => {
    if (model.fields[props.type]["入选标准：肝活检排除肝硬化"] === "否") {
      // 清空其他字段，单选框
      ["入选标准：临床存在特异性门脉高压征象", "入选标准：临床存在非特异性门脉高压征象", "入选标准：组织学表现为特异性PSVD", "入选标准：组织学表现为非特异性"].forEach((key) => {
        model.fields[props.type][key] = null;
      });
      // 清空其他字段，多选框
      ["入选标准：特异性门脉高压征象", "入选标准：非特异性门脉高压征象", "入选标准：特异性PSVD", "入选标准：非特异性"].forEach((key) => {
        model.fields[props.type][key] = [];
      });
    }
  },
  "入选标准：临床存在特异性门脉高压征象": () => {
    if (model.fields[props.type]["入选标准：临床存在特异性门脉高压征象"] === "否") {
      // 清空其他字段，多选框
      model.fields[props.type]["入选标准：特异性门脉高压征象"] = [];
    }
  },
  "入选标准：临床存在非特异性门脉高压征象": () => {
    if (model.fields[props.type]["入选标准：临床存在非特异性门脉高压征象"] === "否") {
      // 清空其他字段，多选框
      model.fields[props.type]["入选标准：非特异性门脉高压征象"] = [];
    }
  },
  "入选标准：组织学表现为特异性PSVD": () => {
    if (model.fields[props.type]["入选标准：组织学表现为特异性PSVD"] === "否") {
      // 清空其他字段，多选框
      model.fields[props.type]["入选标准：特异性PSVD"] = [];
    }
  },
  "入选标准：组织学表现为非特异性": () => {
    if (model.fields[props.type]["入选标准：组织学表现为非特异性"] === "否") {
      // 清空其他字段，多选框
      model.fields[props.type]["入选标准：非特异性"] = [];
    }
  }
};

const isVisible = computed(() => {
  let result = {};
  ["入选标准：肝活检排除肝硬化_是", "入选标准：临床存在特异性门脉高压征象_是", "入选标准：临床存在非特异性门脉高压征象_是", "入选标准：组织学表现为特异性PSVD_是", "入选标准：组织学表现为非特异性_是"].forEach((field) => {
    const key = field.split("_")[0];
    const value = field.split("_")[1];
    result[field] = model.fields[props.type][key] === value;
  });
  return result;
});

// 处理病理复核变化
const handlePathologyReviewChange = (value) => {
  // 只有选择"复核排除"时，标记患者为排除状态
  // 其他选项保留原有的 isExclude 值（由排除标准表单设置）
  if (value === "复核排除") {
    model.isExclude = 1;
  }
  // 其他选项不修改 isExclude，保留之前的值
  console.log("病理复核状态变化:", value, "isExclude:", model.isExclude);
};

onMounted(() => {
  // 初始化时，如果字段为空，则设置为否
  // if (!model.fields?.ischeck) {
    // model.fields?.ischeck = "否";
  // }

  // 初始化时根据病理复核状态设置 isExclude（只处理复核排除的情况）
  if (model.fields?.pathologyReview === "复核排除") {
    model.isExclude = 1;
  } else if (!model.fields?.pathologyReview) {
    // 如果没有病理复核记录，默认设置为未复核，但不修改 isExclude
    model.fields.pathologyReview = "未复核";
  }
})
setTimeout(() => {
  
  // console.log(model.fields?.ischeck,'ischeck');
}, 1);

// 节省代码长度，在模板中使用
const crfFields = computed(() => {
  return model.fields[`${props.type}`];
});
const ischeck = computed(() => {
    return model.fields
})
// 字段自动校验用于赋值 prop
const itemProp = function(prop) {
  return `fields['${props.type}']['${prop}']`;
};
</script>

<template>
  <template v-if="crfFields">
    <div class="title_p">
      <h2>入选标准</h2>
      <p>（满足1+2或1+4或1+3+5可入选，也可多选）</p>
    </div>
    
    <el-form-item label="1. 肝活检排除肝硬化" :prop="itemProp('入选标准：肝活检排除肝硬化')"
                    :rules="crfStore.radioRules('入选标准：肝活检排除肝硬化')">
      <el-radio-group v-model="crfFields['入选标准：肝活检排除肝硬化']" @change="onChange['入选标准：肝活检排除肝硬化']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item v-if="isVisible['入选标准：肝活检排除肝硬化_是']" label="2. 临床存在特异性门脉高压征象"
                    :prop="itemProp('入选标准：临床存在特异性门脉高压征象')"
                    :rules="crfStore.checkboxRules('临床存在特异性门脉高压征象')">
        <el-radio-group v-model="crfFields['入选标准：临床存在特异性门脉高压征象']"
                        @change="onChange['入选标准：临床存在特异性门脉高压征象']">
          <el-radio label="是" prop="是"></el-radio>
          <el-radio label="否" prop="否"></el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item  v-if="isVisible['入选标准：临床存在特异性门脉高压征象_是'] && isVisible['入选标准：肝活检排除肝硬化_是']"
        :prop="itemProp('入选标准：特异性门脉高压征象')"
        :rules="crfStore.checkboxRules('特异性门脉高压征象')">
        <el-checkbox-group v-model="crfFields['入选标准：特异性门脉高压征象']">
          <el-checkbox label="食管胃静脉曲张或异位静脉曲张" prop="食管胃静脉曲张或异位静脉曲张"></el-checkbox>
          <el-checkbox label="门脉高压出血" prop="门脉高压出血"></el-checkbox>
          <el-checkbox label="门脉血管侧支形成" prop="门脉血管侧支形成"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item v-if="isVisible['入选标准：肝活检排除肝硬化_是']" label="3. 临床存在非特异性门脉高压征象"
                    :prop="itemProp('入选标准：临床存在非特异性门脉高压征象')"
                    :rules="crfStore.checkboxRules('临床存在非特异性门脉高压征象')">
        <el-radio-group v-model="crfFields['入选标准：临床存在非特异性门脉高压征象']"
                        @change="onChange['入选标准：临床存在非特异性门脉高压征象']">
          <el-radio label="是" prop="是"></el-radio>
          <el-radio label="否" prop="否"></el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="isVisible['入选标准：临床存在非特异性门脉高压征象_是'] && isVisible['入选标准：肝活检排除肝硬化_是']"
        :prop="itemProp('入选标准：非特异性门脉高压征象')"
        :rules="crfStore.checkboxRules('非特异性门脉高压征象')">
        <el-checkbox-group v-model="crfFields['入选标准：非特异性门脉高压征象']">
          <el-checkbox label="腹水（非恶性的）" prop="腹水（非恶性的）"></el-checkbox>
          <el-checkbox label="脾最长轴>=13cm" prop="脾最长轴>=13cm"></el-checkbox>
          <el-checkbox label="血小板< 150*10^9/L" prop="血小板 < 150*10^9/L"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item v-if="isVisible['入选标准：肝活检排除肝硬化_是']" label="4. 组织学表现为特异性PSVD"
                    :prop="itemProp('入选标准：组织学表现为特异性PSVD')"
                    :rules="crfStore.checkboxRules('组织学表现为特异性PSVD')">
        <el-radio-group v-model="crfFields['入选标准：组织学表现为特异性PSVD']"
                        @change="onChange['入选标准：组织学表现为特异性PSVD']">
          <el-radio label="是" prop="是"></el-radio>
          <el-radio label="否" prop="否"></el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="isVisible['入选标准：组织学表现为特异性PSVD_是'] && isVisible['入选标准：肝活检排除肝硬化_是']"
                    :prop="itemProp('入选标准：特异性PSVD')"
                    :rules="crfStore.checkboxRules('特异性PSVD')">
        <el-checkbox-group v-model="crfFields['入选标准：特异性PSVD']">
          <el-checkbox label="闭塞性门静脉病变（门静脉血管壁增厚、管腔闭塞和门静脉消失）"
                      prop="闭塞性门静脉病变（门静脉血管壁增厚、管腔闭塞和门静脉消失）"></el-checkbox>
          <el-checkbox label="结节性再生性增生" prop="结节性再生性增生"></el-checkbox>
          <el-checkbox label="不完全间隔纤维化（也称不完全间隔肝硬化）"
                      prop="不完全间隔纤维化（也称不完全间隔肝硬化）"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item v-if="isVisible['入选标准：肝活检排除肝硬化_是']" label="5. 组织学表现为非特异性"
                    :prop="itemProp('入选标准：组织学表现为非特异性')"
                    :rules="crfStore.checkboxRules('组织学表现为非特异性')">
        <el-radio-group v-model="crfFields['入选标准：组织学表现为非特异性']"
                        @change="onChange['入选标准：组织学表现为非特异性']">
          <el-radio label="是" prop="是"></el-radio>
          <el-radio label="否" prop="否"></el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="isVisible['入选标准：组织学表现为非特异性_是'] && isVisible['入选标准：肝活检排除肝硬化_是']"
                    :prop="itemProp('入选标准：非特异性')"
                    :rules="crfStore.checkboxRules('非特异性')">
        <el-checkbox-group v-model="crfFields['入选标准：非特异性']">
          <el-checkbox label="门管区异常（动脉增多、扩张、门管区周围血管通路形成及异常血管）"
                      prop="门管区异常（动脉增多、扩张、门管区周围血管通路形成及异常血管）"></el-checkbox>
          <el-checkbox label="结构紊乱：门管区和中央静脉不规则分布"
                      prop="结构紊乱：门管区和中央静脉不规则分布"></el-checkbox>
          <el-checkbox label="非带状分布肝窦扩张"
                      prop="非带状分布肝窦扩张"></el-checkbox>
          <el-checkbox label="轻度窦周纤维化"
                      prop="轻度窦周纤维化"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>

    <!-- 极早期患者-（noPH-PSVD） -->
    <el-form-item label="noPH-PSVD" :prop="itemProp('入选标准：极早期患者')"
                  :rules="crfStore.radioRules('入选标准：极早期患者')">
      <el-radio-group v-model="crfFields['入选标准：极早期患者']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
    </el-form-item>

    <!-- 病理复核单选 -->
    <el-form-item v-if="user.id == model.user_id ||user.role.includes('2')" label="病理复核" prop="fields.pathologyReview">
      <el-radio-group v-model="model.fields.pathologyReview" @change="handlePathologyReviewChange">
        <el-radio label="复核确认" prop="复核确认"></el-radio>
        <el-radio label="复核排除" prop="复核排除"></el-radio>
        <el-radio label="复核待确认" prop="复核待确认"></el-radio>
        <el-radio label="未复核" prop="未复核"></el-radio>
        <el-radio label="NA" prop="NA"></el-radio>
      </el-radio-group>
    </el-form-item>
  </template>
</template>

<style lang="scss" scoped>
.title_p{
  position: relative;
  p{
    margin: 0;
    position: absolute;
    top: 5px;
    left: 150px;
    color: red;
    font-size: 12px;
  }
}
</style>